/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './creative-set-item-page.component.html';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {CreativeSetModel} from './creative-set-api.service';
import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';
import {CreativeSetEditPageComponent} from './creative-set-edit-page.component';
import {CreativeSetAnalysisPageComponent} from './creative-set-analysis-page.component';

@Component({
  standalone: true,
  imports: [AdvertisingSharedModule, CreativeSetEditPageComponent, CreativeSetAnalysisPageComponent],
  selector: 'adn-creative-set-item-page',
  template
})
export class CreativeSetItemPageComponent {
  @Input() state: SignalAdminResourcePageState<CreativeSetModel>;
  @Input() folioFromParam: any;
  @Input() advertiserFromParam: any;
}
